import React from "react";
import CoinsHeldCard from "./CoinsHeldCard";

const CoinsHeld = ({ data }) => {
  return (
    <div className="coins-held-container">
      {data?.map((coin, index) => (
        <CoinsHeldCard data={coin} index={index} />
      ))}
    </div>
  );
};

export default CoinsHeld;
